export { RecordDocuments } from './ui';
